import { render } from "./Navigation.vue?vue&type=template&id=9572080c&scoped=true"
import script from "@/assets/js/navigation.js?vue&type=script&lang=js"
export * from "@/assets/js/navigation.js?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=9572080c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9572080c"]])

export default __exports__